import { EThemeType } from "redux/reducers";

interface Iprop{
  docQuestion?:boolean;
  prompt?:boolean;
}
export const DownArrow = () => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L5 5L9 1"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 18L12.6 16.55L16.15 13H4V11H16.15L12.6 7.45L14 6L20 12L14 18Z"
      fill="currentColor"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.70615 17.2562L4.74365 16.2937L10.0374 11L4.74365 5.70624L5.70615 4.74374L10.9999 10.0375L16.2937 4.74374L17.2562 5.70624L11.9624 11L17.2562 16.2937L16.2937 17.2562L10.9999 11.9625L5.70615 17.2562Z"
      fill="currentColor"
    />
  </svg>
);

export const PlusIcon = ({docQuestion, prompt}:Iprop) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M11 4.58301V17.4163"
      stroke={docQuestion?"#5279E6": prompt ? "#5279E6" : "#7c4dff"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.58203 11H17.4154"
      stroke={docQuestion?"#5279E6": prompt ? "#5279E6" : "#7c4dff"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ContinueIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
  >
    <path
      d="M8 24V8H10.6667V24H8ZM13.3333 24L26.6667 16L13.3333 8V24ZM16 19.3V12.7L21.5 16L16 19.3Z"
      fill="white"
    />
  </svg>
);

export const ImageGeneration = ({
  imageGeneration,
  disable,
  isPrivateChat,
}: {
  imageGeneration?: boolean;
  disable?: boolean;
  isPrivateChat?:boolean;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    style={{ opacity: disable ? "1" : "0.6" }}
  >
    <g clipPath="url(#clip0_6094_20693)">
      <path
        d="M7.68316 0.423482L7.16116 2.02998C6.99927 2.51862 6.72533 2.96261 6.36121 3.32646C5.99709 3.69032 5.55291 3.96395 5.06416 4.12548L3.45616 4.64748L3.42316 4.65648C3.29925 4.7001 3.19194 4.7811 3.11602 4.8883C3.04011 4.9955 2.99934 5.12362 2.99934 5.25498C2.99934 5.38634 3.04011 5.51446 3.11602 5.62166C3.19194 5.72887 3.29925 5.80986 3.42316 5.85348L5.03116 6.37548C5.52019 6.53682 5.96467 6.81036 6.32906 7.17422C6.69345 7.53809 6.96762 7.98218 7.12966 8.47098L7.65166 10.076C7.69527 10.1999 7.77627 10.3072 7.88348 10.3831C7.99068 10.459 8.1188 10.4998 8.25016 10.4998C8.38152 10.4998 8.50964 10.459 8.61684 10.3831C8.72404 10.3072 8.80504 10.1999 8.84866 10.076L9.37066 8.47098C9.53149 7.98052 9.80513 7.53462 10.1696 7.16912C10.534 6.80362 10.9792 6.52871 11.4692 6.36648L13.0772 5.84448C13.2011 5.80086 13.3084 5.71987 13.3843 5.61266C13.4602 5.50546 13.501 5.37734 13.501 5.24598C13.501 5.11462 13.4602 4.9865 13.3843 4.8793C13.3084 4.7721 13.2011 4.6911 13.0772 4.64748L11.4692 4.12548C10.9862 3.95978 10.5483 3.68429 10.1899 3.32068C9.83152 2.95706 9.56238 2.51524 9.40366 2.02998L8.88016 0.424982C8.83686 0.300555 8.7559 0.192692 8.64851 0.116363C8.54113 0.0400337 8.41265 -0.000976562 8.28091 -0.000976562C8.14916 -0.000976563 8.02068 0.0400337 7.9133 0.116363C7.80592 0.192692 7.72496 0.300555 7.68166 0.424982M0.325658 12.32L1.47466 11.948C1.82331 11.8314 2.14006 11.6354 2.39988 11.3753C2.65969 11.1152 2.85544 10.7982 2.97166 10.4495L3.34666 9.30348C3.37771 9.21488 3.43553 9.13811 3.51212 9.08381C3.5887 9.0295 3.68027 9.00032 3.77416 9.00032C3.86804 9.00032 3.95961 9.0295 4.0362 9.08381C4.11278 9.13811 4.1706 9.21488 4.20166 9.30348L4.57366 10.4495C4.68775 10.796 4.8803 11.1115 5.13631 11.3714C5.39233 11.6314 5.70489 11.8287 6.04966 11.948L7.19716 12.32C7.28576 12.351 7.36252 12.4089 7.41683 12.4854C7.47114 12.562 7.50031 12.6536 7.50031 12.7475C7.50031 12.8414 7.47114 12.9329 7.41683 13.0095C7.36252 13.0861 7.28576 13.1439 7.19716 13.175L6.04966 13.5485C5.69997 13.6651 5.3823 13.8617 5.12191 14.1226C4.86152 14.3835 4.66557 14.7016 4.54966 15.0515L4.17766 16.1975C4.1466 16.2861 4.08878 16.3628 4.0122 16.4172C3.93561 16.4715 3.84404 16.5006 3.75016 16.5006C3.65627 16.5006 3.5647 16.4715 3.48812 16.4172C3.41153 16.3628 3.35371 16.2861 3.32266 16.1975L2.94916 15.0515C2.83279 14.7026 2.63681 14.3855 2.37673 14.1254C2.11664 13.8653 1.79958 13.6693 1.45066 13.553L0.303158 13.181C0.214555 13.1499 0.137791 13.0921 0.0834816 13.0155C0.029172 12.9389 0 12.8474 0 12.7535C0 12.6596 0.029172 12.568 0.0834816 12.4914C0.137791 12.4149 0.214555 12.357 0.303158 12.326L0.325658 12.32ZM4.50016 17.852V18.7505C4.50016 19.745 4.89525 20.6989 5.59851 21.4021C6.30177 22.1054 7.25559 22.5005 8.25016 22.5005H18.7502C19.7447 22.5005 20.6985 22.1054 21.4018 21.4021C22.1051 20.6989 22.5002 19.745 22.5002 18.7505V8.25048C22.5002 7.25592 22.1051 6.30209 21.4018 5.59883C20.6985 4.89557 19.7447 4.50048 18.7502 4.50048H14.8682C14.9552 4.73548 14.9992 4.98348 15.0002 5.24448C15.0002 5.51048 14.9547 5.76248 14.8637 6.00048H18.7487C19.3454 6.00048 19.9177 6.23753 20.3396 6.65949C20.7616 7.08145 20.9987 7.65374 20.9987 8.25048V18.7505C20.9987 19.0985 20.9192 19.4255 20.7797 19.721L15.3002 14.243C14.8219 13.7648 14.1734 13.4962 13.4972 13.4962C12.8209 13.4962 12.1724 13.7648 11.6942 14.243L6.21616 19.721C6.07269 19.4176 5.99889 19.086 6.00016 18.7505V15.4655L5.97766 15.521L5.58766 16.724C5.43766 17.099 5.19766 17.414 4.86766 17.654C4.75259 17.7329 4.62939 17.7993 4.50016 17.852ZM17.2472 11.2565C17.4445 11.2565 17.64 11.2176 17.8223 11.1421C18.0047 11.0665 18.1704 10.9558 18.3099 10.8163C18.4495 10.6767 18.5602 10.511 18.6357 10.3287C18.7113 10.1463 18.7502 9.95086 18.7502 9.75348C18.7502 9.5561 18.7113 9.36066 18.6357 9.17831C18.5602 8.99596 18.4495 8.83027 18.3099 8.6907C18.1704 8.55113 18.0047 8.44042 17.8223 8.36489C17.64 8.28936 17.4445 8.25048 17.2472 8.25048C16.8485 8.25048 16.4662 8.40883 16.1844 8.6907C15.9025 8.97257 15.7442 9.35486 15.7442 9.75348C15.7442 10.1521 15.9025 10.5344 16.1844 10.8163C16.4662 11.0981 16.8485 11.2565 17.2472 11.2565ZM14.2427 15.3035L19.7207 20.7815C19.4176 20.926 19.0859 21.0008 18.7502 21.0005H8.25016C7.90216 21.0005 7.57516 20.921 7.27966 20.7815L12.7577 15.3035C12.8552 15.206 12.9709 15.1286 13.0983 15.0758C13.2257 15.0231 13.3623 14.9959 13.5002 14.9959C13.6381 14.9959 13.7746 15.0231 13.902 15.0758C14.0294 15.1286 14.1452 15.206 14.2427 15.3035Z"
        fill={ isPrivateChat ? "#fff" :  "#527AE6"}
      />
    </g>
    <defs>
      <clipPath id="clip0_6094_20693">
        <rect
          width="24"
          height="24"
          fill={imageGeneration ? "#527AE6" : "white"}

        />
      </clipPath>
    </defs>
  </svg>
);

export const UploadDoc = ({
  theme,
  handleRemoveFile,
}: {
  theme?: EThemeType;
  handleRemoveFile?: () => void;
}) => {
  if (theme === "dark") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="57"
        viewBox="0 0 48 57"
        fill="none"
      >
        <path
          d="M12.7771 54.6381H33.2225C37.208 54.6381 39.191 52.6166 39.191 48.6121V31.1313L25.2521 31.1313C22.7878 31.1313 21.6329 29.9566 21.6329 27.4924V13.3613L12.7771 13.3613C8.81124 13.3613 6.80859 15.4018 6.80859 19.407L6.80859 48.6121C6.80859 52.6355 8.81124 54.6381 12.7771 54.6381ZM25.3105 28.4937H38.979C38.8443 27.7043 38.2857 26.9338 37.3813 25.9908L26.7537 15.1906C25.8682 14.2665 25.0599 13.708 24.2508 13.5724V27.4546C24.2508 28.147 24.6172 28.4937 25.3105 28.4937ZM15.588 39.468C14.7986 39.468 14.2401 38.9094 14.2401 38.1586C14.2401 37.407 14.7986 36.8493 15.5872 36.8493H30.4304C31.2009 36.8493 31.7981 37.4078 31.7981 38.1578C31.7981 38.9094 31.2009 39.4672 30.4312 39.4672L15.588 39.468ZM15.588 46.8025C14.7986 46.8025 14.2401 46.2439 14.2401 45.4932C14.2401 44.7424 14.7986 44.1838 15.5872 44.1838H30.4304C31.2009 44.1838 31.7981 44.7424 31.7981 45.4932C31.7981 46.2439 31.2009 46.8025 30.4312 46.8025H15.588Z"
          fill="#7C4DFF"
        />
        <g
          filter="url(#filter0_d_6461_50062)"
          onClick={handleRemoveFile}
          style={{ cursor: "pointer" }}
        >
          <circle cx="34" cy="14" r="10" fill="#171718" />
          <circle cx="34" cy="14" r="9.5" stroke="#7C4DFF" />
        </g>
        <path
          d="M30.8 18L30 17.2L33.2 14L30 10.8L30.8 10L34 13.2L37.2 10L38 10.8L34.8 14L38 17.2L37.2 18L34 14.8L30.8 18Z"
          fill="#7C4DFF"
        />
        <defs>
          <filter
            id="filter0_d_6461_50062"
            x="20"
            y="0"
            width="28"
            height="28"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_6461_50062"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_6461_50062"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="57"
        viewBox="0 0 48 57"
        fill="none"
      >
        <path
          d="M12.7771 54.6381H33.2225C37.208 54.6381 39.191 52.6166 39.191 48.6121V31.1313L25.2521 31.1313C22.7878 31.1313 21.6329 29.9566 21.6329 27.4924V13.3613L12.7771 13.3613C8.81124 13.3613 6.80859 15.4018 6.80859 19.407L6.80859 48.6121C6.80859 52.6355 8.81124 54.6381 12.7771 54.6381ZM25.3105 28.4937H38.979C38.8443 27.7043 38.2857 26.9338 37.3813 25.9908L26.7537 15.1906C25.8682 14.2665 25.0599 13.708 24.2508 13.5724V27.4546C24.2508 28.147 24.6172 28.4937 25.3105 28.4937ZM15.588 39.468C14.7986 39.468 14.2401 38.9094 14.2401 38.1586C14.2401 37.407 14.7986 36.8493 15.5872 36.8493H30.4304C31.2009 36.8493 31.7981 37.4078 31.7981 38.1578C31.7981 38.9094 31.2009 39.4672 30.4312 39.4672L15.588 39.468ZM15.588 46.8025C14.7986 46.8025 14.2401 46.2439 14.2401 45.4932C14.2401 44.7424 14.7986 44.1838 15.5872 44.1838H30.4304C31.2009 44.1838 31.7981 44.7424 31.7981 45.4932C31.7981 46.2439 31.2009 46.8025 30.4312 46.8025H15.588Z"
          fill="#7C4DFF"
        />
        <g
          filter="url(#filter0_d_6130_48281)"
          onClick={handleRemoveFile}
          style={{ cursor: "pointer" }}
        >
          <circle cx="34" cy="14" r="10" fill="white" />
          <circle cx="34" cy="14" r="9.5" stroke="#7C4DFF" />
        </g>
        <path
          d="M30.8 18L30 17.2L33.2 14L30 10.8L30.8 10L34 13.2L37.2 10L38 10.8L34.8 14L38 17.2L37.2 18L34 14.8L30.8 18Z"
          fill="#7C4DFF"
        />
        <defs>
          <filter
            id="filter0_d_6130_48281"
            x="20"
            y="0"
            width="28"
            height="28"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_6130_48281"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_6130_48281"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  }
};

export const UploadImg = ({
  theme,
  handleRemoveFile,
}: {
  theme?: EThemeType;
  handleRemoveFile?: () => void;
}) => {
  if (theme === "dark") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="46"
        height="46"
        viewBox="0 0 46 46"
        fill="none"
      >
        <path
          d="M40.25 36.4167V9.58333C40.25 7.475 38.525 5.75 36.4167 5.75H9.58333C7.475 5.75 5.75 7.475 5.75 9.58333V36.4167C5.75 38.525 7.475 40.25 9.58333 40.25H36.4167C38.525 40.25 40.25 38.525 40.25 36.4167ZM17.0583 26.795L21.0833 31.6442L27.025 23.9967C27.4083 23.4983 28.175 23.4983 28.5583 24.0158L35.2858 32.9858C35.3926 33.1282 35.4576 33.2975 35.4736 33.4748C35.4896 33.652 35.4559 33.8302 35.3763 33.9894C35.2967 34.1486 35.1744 34.2825 35.023 34.376C34.8716 34.4696 34.6971 34.5192 34.5192 34.5192H11.5383C10.7333 34.5192 10.2925 33.5992 10.7908 32.9667L15.5633 26.8333C15.9275 26.335 16.6558 26.3158 17.0583 26.795Z"
          fill="#7C4DFF"
        />

        <g
          filter="url(#filter0_d_6130_48281)"
          onClick={handleRemoveFile}
          style={{ cursor: "pointer" }}
        >
          <circle cx="34" cy="14" r="10" fill="white" />
          <circle cx="34" cy="14" r="9.5" stroke="#7C4DFF" />
        </g>
        <path
          d="M30.8 18L30 17.2L33.2 14L30 10.8L30.8 10L34 13.2L37.2 10L38 10.8L34.8 14L38 17.2L37.2 18L34 14.8L30.8 18Z"
          fill="#7C4DFF"
        />
        <defs>
          <filter
            id="filter0_d_6130_48281"
            x="20"
            y="0"
            width="28"
            height="28"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_6130_48281"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_6130_48281"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="46"
        height="46"
        viewBox="0 0 46 46"
        fill="none"
      >
        <path
          d="M40.25 36.4167V9.58333C40.25 7.475 38.525 5.75 36.4167 5.75H9.58333C7.475 5.75 5.75 7.475 5.75 9.58333V36.4167C5.75 38.525 7.475 40.25 9.58333 40.25H36.4167C38.525 40.25 40.25 38.525 40.25 36.4167ZM17.0583 26.795L21.0833 31.6442L27.025 23.9967C27.4083 23.4983 28.175 23.4983 28.5583 24.0158L35.2858 32.9858C35.3926 33.1282 35.4576 33.2975 35.4736 33.4748C35.4896 33.652 35.4559 33.8302 35.3763 33.9894C35.2967 34.1486 35.1744 34.2825 35.023 34.376C34.8716 34.4696 34.6971 34.5192 34.5192 34.5192H11.5383C10.7333 34.5192 10.2925 33.5992 10.7908 32.9667L15.5633 26.8333C15.9275 26.335 16.6558 26.3158 17.0583 26.795Z"
          fill="#7C4DFF"
        />
        <g
          filter="url(#filter0_d_6130_48281)"
          onClick={handleRemoveFile}
          style={{ cursor: "pointer" }}
        >
          <circle cx="34" cy="14" r="10" fill="white" />
          <circle cx="34" cy="14" r="9.5" stroke="#7C4DFF" />
        </g>
        <path
          d="M30.8 18L30 17.2L33.2 14L30 10.8L30.8 10L34 13.2L37.2 10L38 10.8L34.8 14L38 17.2L37.2 18L34 14.8L30.8 18Z"
          fill="#7C4DFF"
        />
        <defs>
          <filter
            id="filter0_d_6130_48281"
            x="20"
            y="0"
            width="28"
            height="28"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_6130_48281"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_6130_48281"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  }
};

export const DelSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <defs>
        <filter
          id="filter0_d_6531_49891"
          x="-2"
          y="-2"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6531_49891"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6531_49891"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter0_d_6531_49891)">
        <circle cx="14" cy="14" r="10" />
        <circle cx="14" cy="14" r="9.5" stroke="#7C4DFF" />
        <line
          x1="10"
          y1="10"
          x2="18"
          y2="18"
          stroke="#7C4DFF"
          strokeWidth="1"
        />
        <line
          x1="18"
          y1="10"
          x2="10"
          y2="18"
          stroke="#7C4DFF"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export const RemoveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.8 12L4 11.2L7.2 8L4 4.8L4.8 4L8 7.2L11.2 4L12 4.8L8.8 8L12 11.2L11.2 12L8 8.8L4.8 12Z"
      fill="currentColor"
    ></path>
  </svg>
);
